module.exports = __webpack_public_path__ + "img/img-scholarshipprogram2@1x.906e9577.jpg";